import $ from 'jquery';

export default class SiteNavigator {
    constructor() {
        this.selectors = {
            mobile: '.site-navigator-mobile',
            desktop: '.site-navigator',
            page: 'body',
            openButton: '[data-role="open-button"]',
            closeButton: '[data-role="close-button"]',
            dropdownLink: '.menu-item-dropdown',
            cmgArea: '[cmg-area]',
            filter: '.hero-section .filter',
            tagline: '#navbar-tagline',
            hamburgerMenuLines: '.line',
            hamburgerMenuButton: '#menu-button',
            hamburgerMenu: '#hamburgerMenu'
        };

        this.init();
    }

    init() {
        this.$page = $(this.selectors.page);

        this.$mobNavigator = {
            navigator: this.$page.find(this.selectors.mobile)
        };

        this.$mobNavigator.openButton = this.$mobNavigator.navigator.find(this.selectors.openButton);
        this.$mobNavigator.closeButton = this.$mobNavigator.navigator.find(this.selectors.closeButton);
        this.$mobNavigator.dropdowns = this.$mobNavigator.navigator.find(this.selectors.dropdownLink);
        this.$mobNavigator.cmgAreas = this.$mobNavigator.navigator.find(this.selectors.cmgArea);
        this.$mobNavigator.filter = this.$page.find(this.selectors.filter);

        this.$deskNavigator = {
            navigator: this.$page.find(this.selectors.desktop),
        };

        this.$deskNavigator.tagline = this.$deskNavigator.navigator.find(this.selectors.tagline);
        this.$deskNavigator.menuLines = this.$deskNavigator.navigator.find(this.selectors.hamburgerMenuLines);
        this.$deskNavigator.menuButton = this.$deskNavigator.navigator.find(this.selectors.hamburgerMenuButton);
        this.$deskNavigator.menu = this.$deskNavigator.navigator.find(this.selectors.hamburgerMenu);
        if ($("#jv_recruiting_home_page").length) {
            $('#comLogo').attr('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/JV_Web_Resources/CMGHL/JVRecruiting/Home_Images/Logo_CMG_Home_Loans_White_Text.svg');
            $('#jv-logo').attr('src', $('#logo-white').val());
        }
        if ($("#jv_recruiting_video_page").length || $("#recruiting_vip_video_page").length) {
            $("#navbar-tagline h6").css("color", "#FFFFFF");
            $("#personal-card .title").css("color", "#FFFFFF");
            $('#jv-category-navigation').addClass('scroll-class');
            $('#comLogo').attr('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/JV_Web_Resources/CMGHL/JVRecruiting/Home_Images/Logo_CMG_Home_Loans_White_Text.svg');
            $('#jv-logo').attr('src', $('#logo-white').val());
        }
        this.bind();
    }

    bind() {
        this.$mobNavigator.openButton.on({
            'click': (e) => {
                this.$mobNavigator.navigator.addClass('show');
                this.$mobNavigator.filter.addClass('filter-dark');
                this.$page.attr('mobile-menu-opened', '');
            }
        });

        this.$mobNavigator.closeButton.on({
            'click': (e) => {
                this.$mobNavigator.navigator.removeClass('show');
                this.$mobNavigator.filter.removeClass('filter-dark');
                this.$page.removeAttr('mobile-menu-opened');
            }
        });

        this.$mobNavigator.dropdowns.on({
            'click': (e) => {
                e.stopPropagation();

                var $clickedDropdown = $(e.currentTarget);
                if ($clickedDropdown.hasClass('expanded')) {
                    $clickedDropdown.removeClass('expanded');
                    $clickedDropdown.children('expanded').each(function () {
                        $(this).removeClass('expanded');
                    });

                    return;
                }
                else {
                    $clickedDropdown.addClass('expanded');
                }

                var $closestCmgArea = $clickedDropdown.closest('[cmg-area]');
                if ($closestCmgArea.length) {
                    if (!$closestCmgArea.hasClass('active')) {
                        var $inactiveAreasthis = this.$mobNavigator.cmgAreas.not($closestCmgArea);
                        $inactiveAreasthis.removeClass('active');
                        $inactiveAreasthis.find('.expanded').removeClass('expanded');

                        $closestCmgArea.addClass('active');
                    }
                }
            }
        });

        this.$deskNavigator.menuButton.on({
            'click': (e) => {
                var menu = this.$deskNavigator.menu;
                if (menu.hasClass('inactive')) {
                    menu.removeClass('inactive');
                    menu.addClass('active');
                } else {
                    menu.removeClass('active');
                    menu.addClass('inactive');
                }
            }
        });

        $(window).on('scroll', (e) => {
            this.toggleBackground();
        });
    }

    toggleBackground() {
        if (window.pageYOffset > 100) {
            this.$deskNavigator.navigator.addClass('bg-white');

            if ($("#jv_recruiting_home_page").length || $("#recruiting_vip_video_page").length)  {
                $('#comLogo').attr('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/v1666296713/JV_Web_Resources/CMGHL/JVRecruiting/Home_Images/Logo_CMG_Home_Loans_Gray_Text.svg');
                $('#jv-category-navigation').addClass('scroll-class');
                $('#jv-logo').attr('src', $('#logo-url').val());
            }
            if ($("#jv_recruiting_video_page").length || $("#recruiting_vip_video_page").length) {
                $('#comLogo').attr('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/v1666296713/JV_Web_Resources/CMGHL/JVRecruiting/Home_Images/Logo_CMG_Home_Loans_Gray_Text.svg');
                $('#jv-logo').attr('src', $('#logo-url').val());
                $('#jv-category-navigation').addClass('scroll-class');
                $("#navbar-tagline h6").css("color", "#A9A8A9");
                $("#personal-card .title").css("color", "#A9A8A9");
            }
        }
        else if (window.pageYOffset <= 100) {
            this.$deskNavigator.navigator.removeClass('bg-white');
            if ($("#jv_recruiting_home_page").length) {
                $('#comLogo').attr('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/JV_Web_Resources/CMGHL/JVRecruiting/Home_Images/Logo_CMG_Home_Loans_White_Text.svg');
                $('#jv-logo').attr('src', $('#logo-white').val());
                $('#jv-category-navigation').removeClass('scroll-class');
            }
            if ($("#jv_recruiting_video_page").length || $("#recruiting_vip_video_page").length) {
                $('#jv-logo').attr('src', $('#logo-white').val());
                $('#comLogo').attr('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/JV_Web_Resources/CMGHL/JVRecruiting/Home_Images/Logo_CMG_Home_Loans_White_Text.svg');

                $("#navbar-tagline h6").css("color", "#FFFFFF");
                $("#personal-card .title").css("color", "#FFFFFF");
            }
        }
    }
}